import { html } from 'lit';
const WaveRectangle =
  ({ width = '1em', height = '1em', style = '' }: { width?: string, height?: string, style?: string } = {}) =>
    html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${'user-select:none;flex-shrink:0;' + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M19.5 7.5h-15v8.134c.157.102.368.218.627.332.67.297 1.549.534 2.469.534a4.9 4.9 0 0 0 3.506-1.417c.275-.26.833-.789 1.667-1.238.947-.51 2.206-.904 3.865-.904 1.15 0 2.09.176 2.866.461zm1.5 8.762-.075-.081c-.298-.326-.716-.782-1.425-1.145-.658-.337-1.568-.595-2.866-.595-2.664 0-3.919 1.183-4.501 1.732l-.095.09A6.4 6.4 0 0 1 7.596 18c-2.33 0-4.34-1.186-4.596-1.738V6h18z" clip-rule="evenodd"/>
  </svg>
`;
export default WaveRectangle;
